<template>
    <div>
        <page-header :title="$t('yoksis_permissions').toUpper()"
                     @filter-div-status="datatable.filterStatus=$event"
                     :isFilter="false"
                     :isColumns="true"
                     :isNewButton="checkPermission('yoksisservice_addpermit')"
                     @new-button-click="createFormShow">
            <template v-slot:columns>
                <div class="mb-1" v-for="(column,i) in datatable.columns" :key="i">
                    <b-form-checkbox
                        :id="'checkbox-'+i"
                        :name="'checkbox-'+i"
                        :value="false"
                        :unchecked-value="true"
                        v-model="column.hidden"
                        v-if="column.field!='buttons'"
                    >
                        {{ br2space(column.label) }}
                    </b-form-checkbox>
                </div>
            </template>
        </page-header>

        <datatable :rows="datatable.rows"
                   :columns="datatable.columns"
                   :query-params="datatable.queryParams"
                   v-show="datatable.showTable"
                   :is-loading="datatable.isLoading"
                   :showPaginate="false"
                   @on-page-change="onPageChange"
                   @on-per-page-change="onPerPageChange"
                   :title="''"
        />

        <CommonModal ref="formModal"
                     size="md"
                     :onHideOnlyX="true"
                     @bHideModalHeaderClose="clearFormData()">
            <template v-slot:CommonModalTitle>
                <span v-if="formProcess=='create'">{{ $t('new').toUpper() }}</span>
            </template>
            <template v-slot:CommonModalContent>
                <create-form :student-program-id="studentProgram.id"
                             @createFormSuccess="createFormSuccess"
                             v-if="formProcess=='create'"/>
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Template
    import PageHeader from '@/components/page/PageHeader';
    // Component
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';
    // Pages
    import CreateForm from '@/modules/students/pages/student/yoksisPermissions/CreateForm';

    // Services
    import YoksisService from "@/services/YoksisService";
    export default {
        components: {
            PageHeader,

            Datatable,
            CommonModal,

            CreateForm
        },
        props: {
            studentProgram: {}
        },
        data() {
            return {
                formId: null,
                formProcess: null,

                datatable: {
                    rows: [],
                    showTable: true,
                    isLoading: false,
                    filterStatus: true,
                    total: 0,
                    queryParams: {
                        filter: {},
                        limit: -1,
                        page: 1
                    },
                    columns: [
                        {
                            label: '',
                            html: true,
                            field: 'buttons',
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-7-line',
                                    permission: 'yoksisservice_deletepermit',
                                    callback: (row) => {
                                        this.deleteForm(row.id)
                                    }
                                }
                            ]
                        },
                        {
                            field: 'start_date',
                            label: this.spaceToBR(this.toUpperCase('start_date')),
                            hidden: false,
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            field: 'end_date',
                            label: this.spaceToBR(this.toUpperCase('end_date')),
                            hidden: false,
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            field: 'decision_date',
                            label: this.spaceToBR(this.toUpperCase('decision_date')),
                            hidden: false,
                            sortable: false
                        },
                        {
                            field: 'semester_count',
                            label: this.spaceToBR(this.toUpperCase('semester_count')),
                            hidden: false,
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        }
                    ]
                }
            }
        },
        mounted() {
            this.filterClear();
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows()
            },
            filterClear() {
                this.filterSet();
                this.getRows()
            },
            filterSet() {

            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                YoksisService.permitList(this.studentProgram.id).then(res => {
                    this.datatable.rows = res.data.data;
                    this.datatable.total = res.data.pagination.total;
                }).catch((e) => {
                    this.showErrors(e)
                }).finally(() => {
                    this.datatable.isLoading = false
                })
            },

            // Clear
            clearFormData() {
                this.formId = null
                this.formProcess = null
            },

            // Create Form
            createFormShow() {
                this.formId = null;
                this.formProcess = 'create';
                this.$refs.formModal.$refs.commonModal.show();
            },
            createFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.getRows();
            },

            // Delete
            deleteForm(id) {
                this.$swal
                    .fire({
                        text: this.$t('are_you_sure_to_delete'),
                        showCancelButton: true,
                        cancelButtonText: this.$t('no'),
                        confirmButtonText: this.$t('yes')
                    })
                    .then(result => {
                        if (result.isConfirmed) {
                            YoksisService.permitDelete(id).then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getRows();
                            }).catch(e => {
                                this.showErrors(e)
                            })
                        }
                    })
            }
        }
    }
</script>

